import { render, staticRenderFns } from "./MenuPlainItem.vue?vue&type=template&id=75541bea&scoped=true"
import script from "./MenuPlainItem.vue?vue&type=script&lang=js"
export * from "./MenuPlainItem.vue?vue&type=script&lang=js"
import style0 from "./MenuPlainItem.vue?vue&type=style&index=0&id=75541bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75541bea",
  null
  
)

export default component.exports